import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const apiModule = api.tickets
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function getModel () {
  return {
    id: {
      data: 'id',
      title: 'ID',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    createdAt: {
      data: 'createdAt',
      title: 'Дата создания',
      value: null,
      type: 'datetime',
      order: 'desc',
      showOrder: true
    },
    updatedAt: {
      data: 'updatedAt',
      title: 'Дата последнего обновления',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    address: {
      data: 'address',
      title: 'Адрес',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    comment: {
      data: 'comment',
      title: 'Комментарий',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    isClose: {
      data: 'isClose',
      title: 'Статус',
      value: null,
      type: null,
      handler: function (data) {
        let isClose = data.isClose
        if (isClose.value != undefined) isClose = isClose.value
        if (isClose == false) return 'Новая'
        if (isClose == true) return 'Закрыта'
        return null
      },
      order: null,
      showOrder: true
    },
    kontrollerIdMysql: {
      data: 'kontrollerIdMysql',
      title: 'ID кресла',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    images: {
      data: 'images',
      title: 'Изображения',
      value: null,
      type: null
    },
    problems: {
      data: 'problems',
      title: 'Проблемы',
      value: null,
      type: null
    },
    rating: {
      data: 'rating',
      title: 'Рейтинг',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    user: {
      data: 'user',
      title: 'Пользователь',
      value: null,
      type: null
    },
    userId: {
      data: 'userId',
      title: 'ID пользователя',
      value: null,
      type: null
    },
    dealerId: {
      data: 'dealerId',
      title: 'ID диллера',
      value: null,
      type: null
    },
    dealerIdMysql: {
      data: 'dealerIdMysql',
      title: 'ID диллера MySql',
      value: null,
      type: null
    },
    dealerName: {
      data: 'dealerName',
      title: 'Имя диллера',
      value: null,
      type: null
    },
    answer: {
      data: 'answer',
      title: 'Ответ',
      value: null,
      type: null
    }
  }
};

function role () { return localStorage.getItem('role') };

const state = {
  model: getModel(),
  id: null,
  userId: null,
  show: 'all',
  question: getModel(),
  questions: [],
  errMain: null,
  errors: {
    kontrollerIdMysql: null,
    answer: null,
    bonus: null,
    kontroller: null,
    userPhone: null
  },
  tabs: {
    admin: {
      ticket: {
        data: 'ticket',
        title: 'Информация',
        active: true
      },
      crud: {
        data: 'crud',
        title: 'Редактировать',
        active: false
      },
      user: {
        data: 'user',
        title: 'Пользователь',
        active: false
      },
      problems: {
        data: 'problems',
        title: 'Проблемы',
        active: false
      },
      images: {
        data: 'images',
        title: 'Фото',
        active: false
      }
    },
    dealer: {
      ticket: {
        data: 'ticket',
        title: 'Информация',
        active: true
      },
      crud: {
        data: 'crud',
        title: 'Редактировать',
        active: false
      },
      user: {
        data: 'user',
        title: 'Пользователь',
        active: false
      },
      problems: {
        data: 'problems',
        title: 'Проблемы',
        active: false
      },
      images: {
        data: 'images',
        title: 'Фото',
        active: false
      }
    }
  },
  programs: [],
  problems: []
}
const getters = {
  getModel (state) { return state.model },
  getId (state) { return state.id },
  getUserId (state) { return state.userId },
  getShow (state) { return state.show },
  getOne (state) { return state.question },
  getAll (state) { return state.questions },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain },
  getTabs (state) { return state.tabs[role()] },
  getPrograms (state) { return state.programs },
  getProblems (state) { return state.problems }
}
const mutations = {
  setModel (state, data) { state.model = data },
  setId (state, data) { state.id = data },
  setUserId (state, data) { state.userId = data },
  setShow (state, data) { state.show = data },
  setOne (state, data) { state.question = data },
  setAll (state, data) { state.questions = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data },
  setTab (state, data) { state.tabs[role()][data.param].active = data.value },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    };
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order == 'desc') order = 'asc'
    else if (order == 'asc') order = null
    state.model[data.param].order = order
  },
  setPrograms (state, data) { state.programs = data },
  setProblems (state, data) { state.problems = data }
}
const actions = {
  setActiveTab ({ commit, state }, data) {
    let param = data.param
    let tabs = state.tabs[role()]
    for (let tab in tabs) {
      if (param == tab) commit('setTab', { param: tab, value: true })
      else commit('setTab', { param: tab, value: false })
    };
  },
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    if (errors) {
      for (let err in errors) {
        commit('setErrors', { param: err, value: null })
      };
    };
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }, data) {
    commit('setId', null)
    commit('setShow', 'new')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'one')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'all')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      let required = null
      if (data && data.required) required = data.required
      if (state.id) {
        let result = await httpService.get(apiModule[role()].getOne, { id: state.id })
        commit('setOne', mapper.dataToView(required, getModel(), result.data.data))
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      };
      data.params.order = order
      let result = await httpService.get(apiModule[role()].getAll, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async delete ({ state, dispatch }) {
    try {
      await httpService.delete(apiModule.admin.delete, { id: state.id })
      dispatch('toAll')
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getProblems ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.problems[role()].getAll, data)
      let problems = result.data.data
      problems.forEach(problem => { problem.check = false })
      commit('setProblems', problems)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async add ({ state, commit, dispatch }, data) {
    try {
      if (!data.kontroller) commit('setErrors', { param: 'kontroller', value: errorsStr.empty })
      if (!data.userPhone) commit('setErrors', { param: 'userPhone', value: errorsStr.empty })
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (!isErr) {
        let result = await httpService.post(apiModule[role()].add, data)
        commit('setId', result.data.data.id)
        commit('setOne', mapper.dataToView(null, getModel(), result.data.data))
        dispatch('resetAllErr')
        dispatch('toUpdate', { id: result.data.data.id })
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async update ({ state, commit, dispatch }, data) {
    try {
      let dataNew = data.data
      if (!dataNew.kontrollerIdMysql) commit('setErrors', { param: 'kontrollerIdMysql', value: errorsStr.selectValueFromDropdown })
      let errors = state.errors
      if (!errors.kontrollerIdMysql) {
        let result = getModel()
        result = await httpService.patch(apiModule[role()].update, dataNew)
        commit('setId', result.data.data.id)
        dispatch('getOne')
        dispatch('resetAllErr')
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async close ({ state, commit, dispatch }, data) {
    try {
      let dataNew = mapper.dataToRequest(data.data)
      if (!dataNew.answer) commit('setErrors', { param: 'answer', value: errorsStr.empty })
      if (data.bonus && data.bonus < 0) commit('setErrors', { param: 'bonus', value: errorsStr.lessThanZero })
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (!isErr) {
        let result = getModel()
        result = await httpService.patch(apiModule[role()].close, dataNew)
        if (data.bonus) await httpService.post(api.users[role()].giveBonus, { bonus: data.bonus, id: data.userId })
        if (data.countMinutes) await httpService.post(api.kontrollers[role()].startMassageAdmin, { idMysql: data.idMysql, countMinutes: data.countMinutes })
        commit('setId', result.data.data.id)
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
        dispatch('resetAllErr')
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getPrograms ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.kontrollers[role()].getPrograms, { idMysql: data.idMysql })
      result.data.unshift({ countMinutes: 0, price: 0 })
      commit('setPrograms', result.data)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
